import {
    NewAdditionalTimeModelResponse,
    NewAdditionalTimeModelResponseAPI,
} from '../../../../models';

export const createAdditionalTimeAdapter = (
    response: NewAdditionalTimeModelResponseAPI
): NewAdditionalTimeModelResponse => {
    return {
        data: response.employeesWithOverlappingSchedulings,
    };
};
